import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import {
    BankSwitcher, ProfilePage, SearchPulse, MeContext, fetchMe, authHeaders, setInventoryToken,
} from '../components/inventory/InventoryPanel';
import type { Me } from '../components/inventory/InventoryPanel';

// BAR-124: /institution — the bank's own page (panel verdict, 20 Jul: the
// profile is MASTER DATA — Research, Inventory and reporting all read it, so
// it gets its own address instead of hiding inside the inventory). The page
// renders the SAME ProfilePage component the inventory uses — re-homed by
// export, not extracted (no refactor before the integration handover).
// The inventory keeps its own inline door for now (transition state).
const API = process.env.REACT_APP_INVENTORY_API || 'http://localhost:8091';

export default function InstitutionRoute() {
    const navigate = useNavigate();
    const { userData, authToken } = useAuth();
    const signer = userData?.name || userData?.email || 'unknown user';
    useEffect(() => { setInventoryToken(authToken); }, [authToken]);
    // the switcher shows the approved legal name, same as in the inventory
    const [tenantName, setTenantName] = useState<string>('');
    /* in-place bank switching (no reboot — Kawi, 20 Jul) */
    const [epoch, setEpoch] = useState(0);
    /* roles on THIS page too (found 21 Jul: the page had no Me provider, so
       members saw signer acts — the server refused, the page lied) */
    const [me, setMe] = useState<Me>({ uid: 'anonymous', is_signer: true });
    useEffect(() => {
        fetchMe().then(m => { if (m) setMe(m); });
    }, [epoch]);
    useEffect(() => {
        fetch(`${API}/api/inventory/profile`, { headers: authHeaders() })
            .then(r => r.json())
            .then(d => setTenantName(d.identity?.legal_name || ''))
            .catch(() => setTenantName(''));
    }, [epoch]);
    return (
        <MeContext.Provider value={me}>
        <div className="h-full overflow-y-auto bg-bg">
            {/* the page head: the switcher IS the page's context control */}
            <div className="flex items-center gap-0.5 px-6 py-2.5 bg-surface border-b border-border-default sticky top-0 z-10">
                {/* a page TITLE, not a tab — there is nothing to select here
                    (Kawi, 20 Jul); the tinted pill returns only if this page
                    ever splits into tabs */}
                <span className="text-[13px] font-semibold text-fg px-1 py-[7px]">
                    Institution profile</span>
                <div className="ml-auto flex items-center gap-3">
                    {/* the running-search pulse — this page too (21 Jul) */}
                    <SearchPulse />
                    <BankSwitcher activeName={tenantName} signer={signer}
                        onSwitch={() => { setTenantName(''); setEpoch(e => e + 1); }} />
                </div>
            </div>
            {/* no crumb here — this IS the page (Kawi, 20 Jul) */}
            <ProfilePage key={epoch} onBack={() => navigate('/')} signer={signer} showCrumb={false} />
        </div>
        </MeContext.Provider>
    );
}
